import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Navbar, Nav, Container, Image } from "react-bootstrap";
import "../css/navbar.css";
import logo from "../assets/logo_bhadade.png";
import Aos from "aos";
import "aos/dist/aos.css";

export const NavBar = () => {
  const [expanded, setExpanded] = useState(false);
  const location = useLocation();

  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);

  // Collapse navbar whenever route changes
  useEffect(() => {
    setExpanded(false);
  }, [location]);

  return (
    <Navbar
      expand="lg"
      bg="white"
      variant="light"
      sticky="top"
      collapseOnSelect
      expanded={expanded}
      onToggle={() => setExpanded(!expanded)}
      className="shadow-sm py-2 custom-navbar"
    >
      <Container fluid>
        <Navbar.Brand as={Link} to="/" className="d-flex align-items-center">
          <Image
            src={logo}
            alt="Bhadade Catering Logo"
            width="60"
            height="60"
            className="me-2 rounded-circle logo-img"
          />
          <span className="brand-text">BHADADE GROUP</span>
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="main-navbar" />

        <Navbar.Collapse id="main-navbar" className="justify-content-end">
          <Nav className="text-center nav-links">
            <Nav.Link as={Link} to="/" onClick={() => setExpanded(false)}>Home</Nav.Link>
            <Nav.Link as={Link} to="/gallery" onClick={() => setExpanded(false)}>Gallery</Nav.Link>
            <Nav.Link as={Link} to="/events" onClick={() => setExpanded(false)}>Lawn/Hall</Nav.Link>
            <Nav.Link as={Link} to="/goldenpkg" onClick={() => setExpanded(false)}>Golden Package</Nav.Link>
            <Nav.Link as={Link} to="/silverpkg" onClick={() => setExpanded(false)}>Silver Package</Nav.Link>
            <Nav.Link as={Link} to="/about" onClick={() => setExpanded(false)}>About Us</Nav.Link>
            <Nav.Link as={Link} to="/contact" onClick={() => setExpanded(false)}>Contact Us</Nav.Link>
            <Nav.Link as={Link} to="/faq" onClick={() => setExpanded(false)}>FAQs</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};
